import { RouteObject, Outlet } from "react-router-dom"
import Review from "@review/pages/Review"
import { ProvideAuth } from "hooks/useAuth";
import AuthedUrqlProvider from "providers/AuthedUrqlProvider";
import { Protected } from "utils/auth/protect"

const ReviewRoutes: RouteObject[] = [
  {
    path: "review",
    element: (
      <ProvideAuth>
        <AuthedUrqlProvider>
          <Protected>
            <Outlet />
          </Protected>
        </AuthedUrqlProvider>
      </ProvideAuth>
    ),
    children: [
      { index: true, element: <Review /> },
    ],
  },
]

export default ReviewRoutes
